<template>
    <div>
        <b-input-group class="mb-3">
            <b-form-select
                v-if="!isUserProfileTab"
                style="flex: 1 1 0px"
                v-model="filters.region"
                @change="search"
                :options="regionsList"
            />
            <b-form-input
                style="flex: 3 1 0px"
                v-model="filters.search"
                @keyup.enter="search"
                placeholder="Поиск по лотам"
            />
            <template v-slot:append>
                <b-button variant="secondary" class="px-2" @click="reset">Очистить</b-button>
                <b-button variant="primary" class="px-2" @click="search">Поиск</b-button>
            </template>
        </b-input-group>

        <b-navbar type="dark" class="px-0 py-0" toggleable="md">
            <b-navbar-toggle target="filters-dropdown" class="px-0 py-0">
                <b-button variant="primary">В статусе: {{ selectedStatus }}</b-button>
            </b-navbar-toggle>
            <b-collapse is-nav id="filters-dropdown" class="justify-content-between">
                <b-nav small pills class="mb-3 status-filter" :class="{ smaller: isUserProfileTab }">
                    <b-nav-item
                        v-for="status in statuses"
                        v-if="checkUserAccess(status)"
                        :key="status.value"
                        :active="filters.status === status.value"
                        class="col-sm-3 col-md-auto px-sm-0"
                        @click="changeSearchedStatus(status.value)"
                    >
                        {{ status.text }}
                    </b-nav-item>
                </b-nav>
            </b-collapse>
        </b-navbar>

        <div class="d-flex flex-wrap pt-sm-2 justify-content-between" v-if="!isUserProfileTab">
            <div class="col-md-auto px-sm-0">
                <label class="small">Дата окончания представления заявок</label>
                <input-date-picker v-model="filters.dateSubmittingEnd" size="sm" @input="search" />
            </div>
            <div class="col-md-auto px-sm-0">
                <label class="small">Дата проведения торгов</label>
                <input-date-picker v-model="filters.dateStart" size="sm" @input="search" />
            </div>
            <div class="col-md-auto px-sm-0">
                <label class="small">Цена от</label>
                <b-form-input
                    v-model="filters.priceFrom"
                    :type="'text'"
                    :step="1"
                    name="priceFrom"
                    size="sm"
                    @keyup.enter="search"
                />
            </div>
            <div class="col-md-auto px-sm-0">
                <label class="small">Цена до</label>
                <b-form-input
                    v-model="filters.priceTo"
                    :type="'text'"
                    :step="1"
                    name="priceTo"
                    size="sm"
                    @keyup.enter="search"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import {LOT_STATUSES_LIST as baseStatuses} from "@features/Lots/helpers";
    import datePickerOptions from "@/helpers/date-picker-options";
    import InputDatePicker from "@features/Forms/InputDatePicker";

    export default {
    name: "LotsFilters",
    components: { InputDatePicker },
    data: () => ({
        statuses: [{ value: 0, text: "все" }, ...baseStatuses],
        filters: {
            search: "",
            region: 0,
            status: 0,
        },
        datePickerOptions: datePickerOptions,
    }),
    props: {
        isUserProfileTab: {
            type: Boolean,
            default: false,
        },
        savedFilters: {},
        excludeFilters: null,
    },
    computed: {
        regionsList() {
            const list = [{ value: 0, text: "Все регионы" }];
            for (let region of this.$store.state.Regions.list) {
                list.push({ value: region.id, text: region.name });
            }
            return list;
        },
        selectedStatus() {
            return this.statuses.find(status => this.filters.status === status.value).text;
        },
    },
    watch: {
        savedFilters() {
            this.loadFilters();
        },
        excludeFilters() {
            this.removeExcludedStatuses();
        },
    },
    mounted() {
        this.loadFilters();
    },
    created() {
        this.removeExcludedStatuses();
    },
    methods: {
        checkUserAccess(status) {
            if (status.roles) {
                return status.roles.includes(this.$auth.watch?.data?.role)
            }
            return true;
        },
        serializeRequestValues() {
            if (this.filters.priceFrom && typeof this.filters.priceFrom === "String")
                this.filters.priceFrom = parseFloat(this.filters.priceFrom.replace(/ /g, "").replace(",", "."));
            if (this.filters.priceTo && typeof this.filters.priceTo === "String")
                this.filters.priceTo = parseFloat(this.filters.priceTo.replace(/ /g, "").replace(",", "."));
        },
        changeSearchedStatus(status) {
            this.filters.status = status;
            this.search();
        },
        search() {
            this.serializeRequestValues();
            this.$emit("filtersChanged", this.filters);
        },
        reset() {
            this.filters = {
                search: "",
                region: 0,
                status: 0,
            };
            this.search();
        },
        loadFilters() {
            const filters = this.savedFilters ?? {};
            this.filters = { ...this.filters, ...filters };
        },
        removeExcludedStatuses() {
            if (this.excludeFilters) {
                this.statuses = [
                    {
                        value: 0,
                        text: "все",
                    },
                    ...baseStatuses.filter(s => this.excludeFilters.indexOf(s.value) === -1),
                ];
            }
        },
    },
};
</script>
<style scoped>
.status-filter.smaller {
    font-size: 0.7em;
}

.px-sm-0 {
    padding-left: 0;
    padding-right: 0;
}

.pt-sm-2 {
    padding-top: 10px;
}
</style>
